export const OFFLINE_SESSION = {
  maxDurationMs: 12 * 60 * 60 * 1000,
  warningThresholdMs: 60 * 60 * 1000,
  checkIntervalMs: 60 * 1000,
  expiryCheckTimeoutMs: 10_000,
} as const
